var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 27,
    viewBox: "0 0 20.25 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marker-alt",
    "data-name": "Icon awesome-map-marker-alt",
    d: "M9.084,26.455C1.422,15.347,0,14.207,0,10.125a10.125,10.125,0,0,1,20.25,0c0,4.082-1.422,5.222-9.084,16.33a1.266,1.266,0,0,1-2.081,0Zm1.041-12.111a4.219,4.219,0,1,0-4.219-4.219A4.219,4.219,0,0,0,10.125,14.344Z",
    fill: "#7c7c7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinFill);
export default __webpack_public_path__ + "static/media/icon-pin-fill.36c6bcd6.svg";
export { ForwardRef as ReactComponent };